import React, { memo, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions";
import DashboardFeed from "./DashboardFeed/DashboardFeed";
import DasboardGallery from "./CommonComponents/DasboardGallery";
import Celebrations from "./CommonComponents/CelebrationSlider";
import Award from "./CommonComponents/AwardSlider";
import DashboardAnnouncement from "./CommonComponents/DashboardAnnouncement";
import FollowUpSuggestions from "./FollowUpSuggestions/FollowUpSuggestions";
import { DashboardFeatureAndPopularPost } from "./PostsCommonSlider/FeaturePostSlider";
import { DashboardPopularPost } from "./PostsCommonSlider/PopularPostSlider";
import TodaysLeave from "../ApplyLeave/CommonComponents/TodaysLeave";
import RecentArticle from "../ArticleDiscussionBoard/RecentArticle";
import ChatBot_v2 from "../AIChatBot/ChatBot_v2";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import MyActiveSprints from "./CommonComponents/MyActiveSprints";
import MyProjects from "./CommonComponents/MyProjects";
import SprintLifecycle from "./CommonComponents/SprintLifecycle";
import SprintRules from "./CommonComponents/SprintRules";
import ProjectTeamActivity from "./CommonComponents/ProjectTeamActivity";
import { TaskSummary } from "../ProjectManagement/Service/TaskService";
import { DiwaliCelebrationOverlay, DIWALI_EXPIRY_DATE } from "../../DiwaliCelebrationOverlay";

const Dashboard = memo(() => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = getRawPermissionsArray();
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [ticketCreate, setTicketCreate] = useState(false);
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);
  const [dashboardAnnouncement, setDashboardAnnouncement] = useState(false);
  const [dashboardFeed, setDashboardFeed] = useState(false);
  const [dashboardSuggestions, setDashboardSuggestions] = useState(false);
  const [dashboardCelebrations, setDashboardCelebrations] = useState(false);
  const [dashboardAwards, setDashboardAwards] = useState(false);
  const [dashboardOthers, setDashboardOthers] = useState(false);
  const [dashboardChatBot, setDashboardChatBot] = useState(false);
  const [leaveDashboard, setLeaveDashboard] = useState(false);
  const [employeeRead, setEmployeeRead] = useState(false);
  const [wfhRead, setWFHRead] = useState(false);
  const [ticketRead, setTicketRead] = useState(false);
  const [leaveRead, setLeaveRead] = useState(false);
  const [albumRead, setAlbumRead] = useState(false);
  const [dashboardFeedPost, setDashboardFeedPost] = useState(false);
  const [dashboardTaskRead, setDashboardTaskRead] = useState(false);
  const [showDiwaliCelebration, setShowDiwaliCelebration] = useState(false);
  const [showDashboardRockets, setShowDashboardRockets] = useState(false);
  const [loading, setLoading] = useState(true);
  const [MenueIconList, setMenuIconList] = useState({});
  const storedMenu = JSON.parse(
    localStorage.getItem("DynamicMenuJson") || "{}",
  );
  const [activityData, setActivityData] = useState({});
  const history = useHistory();
  const allowedCodes = ["PR-005", "CO-001", "HD-003", "LV-008"];
  const allMenus =
    MenueIconList?.EmployeeFunctionalityGroups?.flatMap(
      (category) => category.EmployeeFunctionalityList || []
    ) || [];
  const uniqueMenus = allMenus.filter(
    (menu, index, self) =>
      index === self.findIndex((m) => m.Code === menu.Code)
  ); const filteredMenus = allowedCodes
    .map((code) => uniqueMenus.find((menu) => menu.Code === code))
    .filter(Boolean);

  useEffect(() => {
    if (localStorage.getItem("showDiwaliCelebrationOnDashboard") === "true") {
      localStorage.removeItem("showDiwaliCelebrationOnDashboard");
      if (Date.now() <= DIWALI_EXPIRY_DATE) {
        setShowDiwaliCelebration(true);
      }
    }

    setMenuIconList(storedMenu);
    permissionAccouncementList();
    fetchActivity();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  async function fetchActivity() {
    setLoading(true);
    const params = {
      DateRange: 0,
    };
    try {
      const response = await TaskSummary(params);
      setLoading(false);
      if (response?.StatusCode === 2000) {
        setActivityData(response?.Data);
        // console.log("ProjectRecentActivity response?.Data", response?.Data);
      }

    } catch (err) {
      console.error("Failed to load activity:", err);
    } finally {
      setLoading(false);
    }
  }

  const permissionAccouncementList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName == "Employee.Create") {
          setEmployeeCreate(true);
        } else if (UserPermission.PermissionName == "Ticket.Add") {
          setTicketCreate(true);
        } else if (UserPermission.PermissionName == "Announcement.Read") {
          setDashboardAnnouncement(true);
        }

        else if (UserPermission.PermissionName == "Leave.Create") {
          setLeaveDashboard(true);
        }
        else if (UserPermission.PermissionName == "Feed.Read") {
          setDashboardFeed(true);
        } else if (UserPermission.PermissionName == "Follower.Suggestions") {
          setDashboardSuggestions(true);
        } else if (UserPermission.PermissionName == "Celebrations.Read") {
          setDashboardCelebrations(true);
        } else if (UserPermission.PermissionName == "Awards.Read") {
          setDashboardAwards(true);
        } else if (UserPermission.PermissionName == "Article.Read") {
          setDashboardOthers(true);
        } else if (UserPermission.PermissionName == "AI.Read") {
          setDashboardChatBot(true);
        }
        else if (UserPermission.PermissionName == "Employee.Read") {
          setEmployeeRead(true);
        }

        else if (UserPermission.PermissionName == "Ticket.Read") {
          setTicketRead(true);
        }

        else if (UserPermission.PermissionName == "Leave.Read") {
          setLeaveRead(true);
        }

        else if (UserPermission.PermissionName == "Album.Read") {
          setAlbumRead(true);
        }

        else if (UserPermission.PermissionName == "WFH.Read") {
          setWFHRead(true);
        }
        else if (UserPermission.PermissionName == "Feed.Post") {
          setDashboardFeedPost(true);
        }

        else if (UserPermission.PermissionName == "Task.Read") {
          setDashboardTaskRead(true);
        }
        // else if (UserPermission.PermissionName == "Project.Read") {
        //   setDashboardProjectRead(true);
        // }

      });
    }
  };

  const redirectToAnotherPage = (item) => {
    if (item?.Code == "CO-001") {
      history.push(`/TeamDirectory`);
    } else if (item?.Code == "PR-005") {
      history.push(`/Project/Dashboard`);
    } else if (item?.Code == "HD-003") {
      history.push(`/Ticket`);
    } else if (item?.Code == "LV-008") {
      history.push(`/Calendar`);
    }
  };

  const toggleDropdown = () => setShow((prev) => !prev);
  return (
    <div>
      {showDiwaliCelebration && (
        <DiwaliCelebrationOverlay
          isActive={showDiwaliCelebration}
          variant="full"
          onComplete={() => {
            setShowDiwaliCelebration(false);
            setShowDashboardRockets(true);
          }}
        />
      )}
      {showDashboardRockets && (
        <DiwaliCelebrationOverlay
          isActive={showDashboardRockets}
          variant="dashboard"
          durationMs={10000}
          onComplete={() => setShowDashboardRockets(false)}
        />
      )}
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center mb-2">
            <div
              className="me-auto d-flex align-items-center"
              style={{ gap: "7px" }}
            >
              <div className="dashboard-title font-w600 mb-0">
                <h2 className="dashboard-titleh2">
                  <span>{T("Hello")},&nbsp;</span>
                  {userDetails.FullName}
                  <span className="empid">
                    (id:{" "}
                    {userDetails.EmploymentId
                      ? userDetails.EmploymentId
                      : "N/A"}
                    )
                  </span>
                </h2>
                <p>{userDetails.OrganizationName} </p>
              </div>
            </div>

            <div className="rightside-tabs mb-0 rt-bg-transparent">

              {/* <div className="rightside-tabs mb-0 rt-bg-transparent"> */}
              {filteredMenus.map((menu, i) => (
                <div className="dashboard-calendarico" key={menu.Id || i}>
                  <Link title={menu.FeatureName} to="#" onClick={() => redirectToAnotherPage(menu)}>
                    <img
                      src={menu.IconPath}
                      alt={menu.FeatureName}
                      style={{ width: "27px" }}
                    />
                  </Link>
                </div>
              ))}



              {/* </div> */}
              {/* {dashboardTaskRead && (
                <div className="dashboard-calendarico">
                  <Link title="Project Management" to="/Project/Dashboard">
                    <img src="/images/menu-icon/projectManagement44.png" />
                  </Link>
                </div>
              )}
              {employeeRead && (
                <div className="dashboard-calendarico">
                  <Link title="Team Directory" to="/TeamDirectory">
                    <img src="/images/org-img/Teams.png" />
                  </Link>
                </div>
              )}
              {ticketRead && (
                <div className="dashboard-calendarico ">
                  <Link title="Ticket Dashboard" to="/Ticket">
                    <img src="/images/org-img/Ticket.png" />
                  </Link>
                </div>
              )}
              {leaveRead && (
                <div className="dashboard-calendarico">
                  <Link title="Leave Calendar" to="/Calendar">
                    <img src="/images/org-img/Calander.png" />
                  </Link>
                </div>
              )} */}
              <div
                className="nav-item dropdown notification_dropdown dashboard-addmore"
                ref={dropdownRef}
              >
                <a
                  className="nav-link p-0"
                  onClick={toggleDropdown}
                  style={{
                    fontSize: "15px",
                    color: "#020202",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    fill="currentColor"
                    className="bi bi-plus-lg"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                    ></path>
                  </svg>
                </a>
                {show && (
                  <div
                    className="dropdown-menu dropdown-menu-end p-0 show"
                    data-bs-popper="none"
                  >
                    <div className="widget-timeline dz-scroll style-1 ps">
                      <ul className="timeline">
                        {employeeCreate && (
                          <li className="mb-0">
                            <div className="timeline-badge primary d-none"></div>
                            <Link
                              to="/Employee/Add"
                              className="timeline-panel text-muted d-inline-flex profiledrop"
                            >
                              <ul className="profiledropul">
                                <li>
                                  <img src="/images/new-post.png" />
                                </li>
                              </ul>
                              <h6>New Employee</h6>
                            </Link>
                          </li>
                        )}
                        {leaveDashboard && (
                          <li className="mb-0">
                            <div className="timeline-badge primary d-none"></div>
                            <Link
                              to="/LeaveDashboard"
                              className="timeline-panel text-muted d-inline-flex profiledrop"
                            >
                              <ul className="profiledropul">
                                <li>
                                  <img src="/images/new-post.png" />
                                </li>
                              </ul>
                              <h6>New Leave</h6>
                            </Link>
                          </li>
                        )}
                        {ticketCreate && (
                          <li className="mb-0">
                            <div className="timeline-badge primary d-none"></div>
                            <Link
                              to="/AddTicket"
                              className="timeline-panel text-muted d-inline-flex profiledrop"
                            >
                              <ul className="profiledropul">
                                <li>
                                  <img src="/images/new-post.png" />
                                </li>
                              </ul>
                              <h6>New Ticket</h6>
                            </Link>
                          </li>
                        )}
                        {wfhRead && (
                          <li className="mb-0">
                            <div className="timeline-badge primary d-none"></div>
                            <Link
                              to="/WfhDashboard"
                              className="timeline-panel text-muted d-inline-flex profiledrop"
                            >
                              <ul className="profiledropul">
                                <li>
                                  <img src="/images/new-post.png" />
                                </li>
                              </ul>
                              <h6>New WFH</h6>
                            </Link>
                          </li>
                        )}

                        {dashboardTaskRead && (
                          <li className="mb-0">
                            <div className="timeline-badge primary d-none"></div>
                            <Link
                              to="/Project/Tasks/All"
                              className="timeline-panel text-muted d-inline-flex profiledrop"
                            >
                              <ul className="profiledropul">
                                <li>
                                  <img src="/images/new-post.png" />
                                </li>
                              </ul>
                              <h6>New Task</h6>
                            </Link>
                          </li>
                        )}
                      </ul>
                      <div
                        className="ps__rail-x"
                        style={{ left: "0px", bottom: "0px" }}
                      >
                        <div
                          className="ps__thumb-x"
                          tabIndex="0"
                          style={{ left: "0px", width: "0px" }}
                        ></div>
                      </div>
                      <div
                        className="ps__rail-y"
                        style={{ top: "0px", right: "0px" }}
                      >
                        <div
                          className="ps__thumb-y"
                          tabIndex="0"
                          style={{ top: "0px", height: "0px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-3 first col-md-6" id="upcomings">

            {albumRead && <DasboardGallery />}
            {dashboardAwards && <Award />}
            {dashboardCelebrations && <Celebrations />}
            {(dashboardTaskRead) && (<MyActiveSprints />)}
            {(dashboardTaskRead) && (<MyProjects />)}
            {(dashboardTaskRead) && (<SprintLifecycle />)}
            {(dashboardTaskRead) && (<SprintRules />)}
          </div>

          {(dashboardFeed || dashboardFeedPost || dashboardTaskRead) && (
            <div className="col-xl-6 second" id="feeds">
              <div className="row g-3">

                <DashboardFeed activityData={activityData} loading={loading} />
              </div>
            </div>
          )}

          <div
            className="col-xl-3 third col-md-6 dashboard-leave-box"
            id="info"
          >

            {leaveRead && <TodaysLeave />}
            {dashboardAnnouncement && <DashboardAnnouncement />}

            {dashboardOthers &&
              <RecentArticle />
            }

            {dashboardFeed && (
              <>
                <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
                  <div className="card award">
                    <div className="card-body">
                      <div className="custom-tab-1 custom-tab-11">
                        <div className="slide22">
                          <strong className="upcome">
                            {T("Featured Posts")}
                          </strong>
                          <Link to="/Feed/Featured" className="more-icon">
                            <i className="fa fa-angle-right"></i>
                          </Link>
                          <DashboardFeatureAndPopularPost />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
                  <div className="card award">
                    <div className="card-body">
                      <div className="custom-tab-1 custom-tab-11">
                        <div className="slide22">
                          <strong className="upcome">
                            {T("Popular Posts")}
                          </strong>
                          <Link to="/Feed/Popular" className="more-icon">
                            <i className="fa fa-angle-right"></i>
                          </Link>
                          <DashboardPopularPost />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {dashboardSuggestions && <FollowUpSuggestions />}
            {(dashboardTaskRead) && (<ProjectTeamActivity activityData={activityData} loading={loading}  />)}

            {dashboardChatBot && <ChatBot_v2 />}
          </div>
        </div>
      </div>
    </div>
  );
});
export default Dashboard;
